import { Stack, Typography, Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

function List1({ operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'EquipementType',
      headerName: '-',
      width: 310,
      flex: 1,
      editable: true,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" paddingBottom="10px">
            <Box sx={{ width: '60px', height: '60px', marginRight: '15px' }}>
              <img src={params.row.entreprise?.Logo} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '22px', fontWeight: '600' }}>
                {' '}
                {params.row.Name}
              </Typography>
              <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>
                {' '}
                {params.row.entreprise?.Name}
              </Typography>

              <Typography sx={{ fontSize: '14px', color: '#898989' }}>
                {convertToUserDateFormate(siteUser.user, params.row.BeginDate)} -{' '}
                {convertToUserDateFormate(siteUser.user, params.row.endDate)}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: '#898989' }}>
                {' '}
                {params.row.City}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
  ]

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('parcoursPro.titleExperience') /* LAP-733 (GE022) */} ({operations.count})
      </Typography>

      <DataGrid
        getRowHeight={() => 'auto'}
        // getEstimatedRowHeight={() => 200}
        sx={{
          height: 700,
          '.MuiDataGrid-footerContainer': { display: 'none' },
          '& .MuiDataGrid-columnHeaders': { display: 'none' },
          '& .MuiDataGrid-virtualScroller': {
            marginTop: '10px !important',
            height: '390px !important',
          },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(e) => navigate(`/parcourspro/experience/${e.row.id}`)}
      />
    </div>
  )
}
export default List1
